import PropTypes from "prop-types";
import { typeShell } from "../../../styles/typeShell";

const Loading = ({ isLoading, message = "読み込み中...", children, fullscreen = false }) => {
    if (isLoading) {
        return (
            <div
                className={[
                    "flex flex-col items-center justify-center text-center",
                    fullscreen
                        ? "fixed inset-0 z-[1000] min-h-screen bg-bg-primary p-8"
                        : "px-4 py-8 bp-md:px-8 bp-md:py-12",
                ].join(" ")}
                role="status"
                aria-live="polite"
                aria-busy="true"
            >
                <div
                    className="mb-4 h-9 w-9 animate-spin rounded-full border-[3px] border-solid border-border-subtle border-t-button-primary motion-reduce:animate-none motion-reduce:opacity-80 bp-md:h-10 bp-md:w-10 bp-md:border-4"
                    aria-hidden="true"
                />
                {message ? (
                    <p className={`m-0 ${typeShell.bodyMedium} text-text-secondary`}>
                        {message}
                    </p>
                ) : null}
            </div>
        );
    }
    return children;
};

Loading.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    message: PropTypes.string,
    children: PropTypes.node,
    fullscreen: PropTypes.bool,
};

export default Loading;
